import { createSlice } from '@reduxjs/toolkit';
import { groupBy } from 'lodash';
import { listService } from 'src/services/CommonService';

interface ServicesState {
    isServiceLoading: boolean;
    services: any[];
    servicesList: any[];
    serviceTypes: any;
    handlingUnitOptions: any[];
    isHandlingUnitLoading: boolean;
    vehicleTypeOptions: any[];
    isVehicleTypeLoading: boolean;
    vehicleAttrOptions: any[];
    isVehicleAttrLoading: boolean;
    vehicleSizeOptions: any[];
}

const initialState: ServicesState = {
    isServiceLoading: false,
    services: [],
    servicesList: [],
    serviceTypes: {},
    handlingUnitOptions: [],
    isHandlingUnitLoading: false,
    vehicleTypeOptions: [],
    isVehicleTypeLoading: false,
    vehicleAttrOptions: [],
    isVehicleAttrLoading: false,
    vehicleSizeOptions: [],
};

const servicesSlice = createSlice({
    name: 'services',
    initialState,
    reducers: {
        setIsServiceLoading: (state, action) => {
            state.isServiceLoading = action.payload;
        },
        setServices: (state, action) => {
            state.services = action.payload;
        },
        setServicesList: (state, action) => {
            state.servicesList = action.payload;
        },
        setServiceTypes: (state, action) => {
            state.serviceTypes = action.payload;
        },
        setHandlingUnitOptions: (state, action) => {
            state.handlingUnitOptions = action.payload;
        },
        setIsHandlingUnitLoading: (state, action) => {
            state.isHandlingUnitLoading = action.payload;
        },
        setVehicleTypeOptions: (state, action) => {
            state.vehicleTypeOptions = action.payload;
        },
        setIsVehicleTypeLoading: (state, action) => {
            state.isVehicleTypeLoading = action.payload;
        },
        setVehicleAttrOptions: (state, action) => {
            state.vehicleAttrOptions = action.payload;
        },
        setIsVehicleAttrLoading: (state, action) => {
            state.isVehicleAttrLoading = action.payload;
        },
        setVehicleSizeOptions: (state, action) => {
            state.vehicleSizeOptions = action.payload;
        },
    },
});

export const {
    setIsServiceLoading,
    setServices,
    setServicesList,
    setServiceTypes,
    setHandlingUnitOptions,
    setIsHandlingUnitLoading,
    setVehicleTypeOptions,
    setIsVehicleTypeLoading,
    setVehicleAttrOptions,
    setIsVehicleAttrLoading,
    setVehicleSizeOptions,
} = servicesSlice.actions;

// Thunks
export const fetchServices = (): any => async (dispatch: any) => {
    dispatch(setIsServiceLoading(true));
    dispatch(setIsVehicleAttrLoading(true));

    try {
        const response = await listService({});

        if (response?.data && response?.status) {
            const formattedList = response.data.map((item: any) => ({
                id: item.id,
                label: item.name,
                value: item.slug,
            }));

            formattedList.push({
                id: '',
                label: 'Other',
                value: 'other',
            });

            dispatch(setServicesList(formattedList));
            dispatch(setServices(response.data));

            const serviceByGroup = groupBy(response.data, (val) => val.type);
            dispatch(setServiceTypes(serviceByGroup));

            const vehicleAttrOptions = response.data
                .filter((vt: any) => vt.isOnlyForFTL || vt.loadLinkName?.toLowerCase() === 'hazmat')
                .map((vt: any) => ({
                    label: vt.loadLinkName,
                    value: vt.loadLinkTerm,
                    truckstop: vt.truckstop,
                }));
            dispatch(setVehicleAttrOptions(vehicleAttrOptions));
        }
    } catch (error) {
        console.error('Error fetching services:', error);
    } finally {
        dispatch(setIsServiceLoading(false));
        dispatch(setIsVehicleAttrLoading(false));
    }
};

export default servicesSlice.reducer;
